import React from "react";
import { Link } from "gatsby";
import NavigationLink from "./NavigationLink";
import resolveLink from "src/utils/resolveLink";

const NavigationSection = (item) => {
  return (
    <div className="mb-4 flex flex-col">
      {item.target.cached_url ? (
        <Link
          className={`font-display hover:after:bg-red text-blue mb-2 text-lg uppercase after:block after:h-px after:bg-gray-300 after:transition after:duration-300`}
          to={resolveLink(`/${item.target.cached_url}`)}
        >
          {item.label}
        </Link>
      ) : (
        <h5
          className={`font-display text-blue mb-2 text-lg uppercase after:block after:h-px after:bg-gray-300`}
        >
          {item.label}
        </h5>
      )}
      {item.links.map((link, index) => {
        return <NavigationLink {...link} theme={item.theme} key={index} />;
      })}
    </div>
  );
};

export default NavigationSection;
